import { UseCase } from "src/app/base/use-case";
import { IBranchExchangeModel } from "../models/branch-exchange.model";
import { BranchRepository } from "../repository/branch.repository";
import { Observable } from "rxjs";

export class BranchExchangeUsecase implements UseCase<number, IBranchExchangeModel> {
  constructor(private branchRepository: BranchRepository) {}

  execute(id: number): Observable<IBranchExchangeModel> {
	  return this.branchRepository.getBranchesExchange(id);
  }
}